/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { FC } from "react";

import { HomeStyle } from "./styles";

import ViewTokenData from "../../ViewTokenData";
import { Box } from "@mui/material";
import TemplatePage from "../TemplatePage";
import Page12TokenDCreate from "../../Page12TokenDCreate";

const CreateToken: FC = () => {
  return (
    <TemplatePage>
      <Box sx={HomeStyle.mainContainer}>
        <Page12TokenDCreate passedData={""} />
        <Box>
          <a
            href="https://arpt.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            style={HomeStyle.arptUrl}
          >
            ARPT
          </a>
        </Box>
      </Box>
    </TemplatePage>
    
  );
};

export default CreateToken;
